<template>
  <DashboardChartWrapper
    title="Produits par categorie"
    :loading="loading"
    :error="error"
    @retry="refresh"
  >
    <Bar v-if="chartData" :data="chartData" :options="chartOptions" />
  </DashboardChartWrapper>
</template>

<script setup>
import { computed } from 'vue'
import { Bar } from 'vue-chartjs'
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from 'chart.js'
import { useDashboard } from '@/composables/useDashboard'
import { formatCurrency } from './helpers'
import DashboardChartWrapper from './DashboardChartWrapper.vue'

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend)

const { data, loading, error, refresh } = useDashboard('/dashboard/charts/products-by-category')

const chartData = computed(() => {
  if (!data.value || !Array.isArray(data.value)) return null
  return {
    labels: data.value.map(d => d.label),
    datasets: [
      {
        label: 'Nb produits',
        data: data.value.map(d => d.product_count),
        backgroundColor: '#3b82f6',
        borderRadius: 4,
        yAxisID: 'y'
      },
      {
        label: 'Valeur stock',
        data: data.value.map(d => d.stock_value),
        backgroundColor: '#10b981',
        borderRadius: 4,
        yAxisID: 'y1'
      }
    ]
  }
})

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { position: 'top', labels: { usePointStyle: true, pointStyle: 'circle' } },
    tooltip: {
      callbacks: {
        label: (ctx) => {
          if (ctx.datasetIndex === 1) return `Valeur stock: ${formatCurrency(ctx.raw)}`
          return `Nb produits: ${ctx.raw}`
        }
      }
    }
  },
  scales: {
    y: { type: 'linear', position: 'left', beginAtZero: true },
    y1: { type: 'linear', position: 'right', grid: { drawOnChartArea: false }, ticks: { callback: v => formatCurrency(v) } }
  }
}
</script>
